(function () {
  function getCartDrawerItems() {
    return document.querySelector('cart-drawer-items');
  }

  function getLineQuantity(line) {
    const input = document.getElementById('Drawer-quantity-' + line);
    if (input && input.value !== '') return parseInt(input.value, 10);
    return null;
  }

  function clearCartDrawerErrors() {
    const errEl = document.getElementById('CartDrawer-CartErrors');
    if (errEl) errEl.textContent = '';
  }

  function applyCartChangeResponse(cartEl, parsedState) {
    clearCartDrawerErrors();

    cartEl.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

    if (!parsedState.sections) {
      throw new Error('Cart response missing sections');
    }

    cartEl.getSectionsToRender().forEach(function (section) {
      const html = parsedState.sections[section.section];
      if (!html) return;
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      if (!elementToReplace) return;
      try {
        const inner = cartEl.getSectionInnerHTML(html, section.selector);
        if (inner != null) {
          elementToReplace.innerHTML = inner;
        }
      } catch (e) {
        console.error('Cart section render failed', section.section, e);
        throw e;
      }
    });

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: parsedState }));
    cartEl.disableLoading();
  }

  function changeLineSellingPlan(line, sellingPlanId, lineKey) {
    const cartEl = getCartDrawerItems();
    if (!cartEl || !window.routes || !window.routes.cart_change_url) return Promise.resolve();

    const qty = getLineQuantity(line);
    const toggle = document.querySelector('[data-cart-subscription-toggle][data-line="' + line + '"]');
    const fallbackQty = (function () {
      const sel = document.querySelector('[data-cart-subscription-plan-select][data-line="' + line + '"]');
      const q =
        (toggle && toggle.dataset && toggle.dataset.quantity) ||
        (sel && sel.dataset && sel.dataset.quantity) ||
        '1';
      const n = parseInt(q, 10);
      return !isNaN(n) && n > 0 ? n : 1;
    })();
    const quantity = qty != null && !isNaN(qty) ? qty : fallbackQty;
    if (!quantity || quantity < 1 || isNaN(quantity)) {
      cartEl.disableLoading();
      return Promise.resolve();
    }

    const key = (lineKey && String(lineKey).trim()) || (toggle && toggle.dataset && toggle.dataset.lineKey);
    const lineNum = parseInt(line, 10);
    if (!key && (!lineNum || lineNum < 1)) {
      cartEl.disableLoading();
      const errors = document.getElementById('CartDrawer-CartErrors');
      if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
      return Promise.resolve();
    }

    cartEl.enableLoading(line);

    const body = {
      quantity: quantity,
      sections: cartEl.getSectionsToRender().map(function (s) {
        return s.section;
      }),
      sections_url: window.location.pathname,
    };
    if (key) {
      body.id = key;
    } else {
      body.line = lineNum;
    }

    if (sellingPlanId === null || sellingPlanId === undefined || sellingPlanId === '') {
      body.selling_plan = null;
    } else {
      body.selling_plan = Number(sellingPlanId);
    }

    return fetch(window.routes.cart_change_url, {
      ...fetchConfig(),
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.text().then(function (text) {
          let parsed;
          try {
            parsed = JSON.parse(text);
          } catch (e) {
            throw new Error('Invalid cart response');
          }
          if (!response.ok) {
            const msg =
              (parsed && (parsed.message || parsed.description || parsed.error)) || response.statusText || 'Cart error';
            throw new Error(typeof msg === 'string' ? msg : 'Cart error');
          }
          return parsed;
        });
      })
      .then(function (parsedState) {
        applyCartChangeResponse(cartEl, parsedState);
      })
      .catch(function (err) {
        cartEl.querySelectorAll('.loading-overlay').forEach(function (o) {
          o.classList.add('hidden');
        });
        cartEl.disableLoading();
        const errors = document.getElementById('CartDrawer-CartErrors');
        if (errors && window.cartStrings) {
          var msg =
            err && err.message
              ? err.message
              : typeof err === 'string'
                ? err
                : window.cartStrings.error;
          errors.textContent = msg || window.cartStrings.error;
        }
      });
  }

  document.addEventListener('click', function (e) {
    const toggle = e.target.closest('[data-cart-subscription-toggle]');
    if (!toggle || !document.querySelector('cart-drawer') || !document.querySelector('cart-drawer').contains(toggle)) return;
    e.preventDefault();
    const line = toggle.dataset.line;
    const lineKey = toggle.dataset.lineKey;
    const subscribed = toggle.dataset.subscribed === 'true';
    const defaultId = toggle.dataset.defaultPlanId;
    if (subscribed) {
      changeLineSellingPlan(line, null, lineKey);
    } else if (defaultId) {
      changeLineSellingPlan(line, defaultId, lineKey);
    }
  });

  document.addEventListener('change', function (e) {
    const sel = e.target.closest('[data-cart-subscription-plan-select]');
    if (!sel || !document.querySelector('cart-drawer') || !document.querySelector('cart-drawer').contains(sel)) return;
    const line = sel.dataset.line;
    const lineKey = sel.dataset.lineKey;
    if (!sel.value) return;
    changeLineSellingPlan(line, sel.value, lineKey);
  });
})();
